import api from './api';

export interface CapacityUser {
  userId: string;
  displayName: string;
  avatarUrl: string;
}
export interface CapacityRoom {
  roomId: string;
  name: string;
  owner: CapacityUser;
}
export interface CapacityUserRooms {
  user: CapacityUser;
  roomCount: number;
  roomCountCapped: boolean;
  rooms: { room: CapacityRoom; role: string }[];
  nextCursor: string;
}
export interface RoomCapacity {
  room: CapacityRoom;
  memberCount: number;
  memberCountCapped: boolean;
  maxMembers: number;
  defaultMaxMembers: number;
  overridden: boolean;
  currentVersion: number;
  latestVersion: number;
  deploymentState: string;
  canExpand: boolean;
}
export interface CapacityPublication {
  versionNumber: number;
  deploymentNumber: number;
  deploymentState: string;
}
const base = '/api/v1/admin/room-capacity';
export const roomCapacityApi = {
  user: (userId: string, relation: string, cursor = '') =>
    api.get<never, CapacityUserRooms>(
      `${base}/users/${encodeURIComponent(userId)}`,
      {
        params: { relation, cursor },
      },
    ),
  room: (roomId: string) =>
    api.get<never, RoomCapacity>(`${base}/rooms/${encodeURIComponent(roomId)}`),
  expand: (
    roomId: string,
    data: { maxMembers: number; expectedVersion: number; reason: string },
  ) =>
    api.post<never, CapacityPublication>(
      `${base}/rooms/${encodeURIComponent(roomId)}/expand`,
      data,
    ),
};
